<template>
  <div class="hero">
    <div class="hero__block">
      <h1 class="hero__block-title">{{ t('home.hero.title1') }} <span>{{ t('home.hero.title2') }}</span></h1>
      <p class="hero__block-text">{{ t('home.hero.text') }}</p>
      <router-link :to="translations.i18nRoute({ name: 'store' })">
        <ui-button class="hero__block-button">{{ t('buttons.shop') }}</ui-button>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiButton from "@/components/ui/ui-button.vue";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.hero {
  background-image: url(@images/heroBg.png);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  padding-block: 140px;
  position: relative;
  margin-bottom: 50px;

  &::after {
    content: "";
    position: absolute;
    z-index: 1;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  &__block {
    position: relative;
    z-index: 2;
    padding: 55px 70px;
    border-radius: 36px;
    background-color: $white;
    box-shadow: 0 0 30px -1px rgba(0, 0, 0, 0.18);
    width: 1000px;
    margin-inline: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    &-title {
      color: #2F2F2F;
      text-align: center;
      font-size: 72px;
      font-weight: 600;
      line-height: 78px;

      & span {
        background: linear-gradient(90deg, #FF6162 0%, #EB5393 93.44%, #F4915D 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 78px;
        font-weight: 600;
        line-height: 78px;
      }
    }

    &-text {
      color: #2F2F2F;
      text-align: center;
      font-family: "Readex Pro", sans-serif;
      font-size: 21px;
      font-weight: 300;
      line-height: 28px;
    }

    &-button {
      width: fit-content !important;
    }
  }
}

@media (max-width: 1150px) {
  .hero {
    &__block {
      width: 75%;
    }
  }
}

@media (max-width: 750px) {
  .hero {
    &__block {
      padding: 35px 40px;

      &-title {
        font-size: 48px;
        line-height: 54px;

        & span {
          font-size: 48px;
          line-height: 54px;
        }
      }

      &-text {
        font-size: 18px;
        line-height: 22px;
      }
    }
  }
}

@media (max-width: 450px) {
  .hero {
    padding-block: 75px;

    &__block {
      padding: 25px 30px;

      &-title {
        font-size: 36px;
        line-height: 40px;

        & span {
          font-size: 36px;
          line-height: 40px;
        }
      }

      &-text {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
}
</style>